import React from 'react';
const pillars = [{
  title: 'Six pieces a season',
  body: 'We release only what we would wear for a decade. No drops, no logos, no noise.'
}, {
  title: 'Modal fibre only',
  body: 'Gentle on skin, breathable, and made to last — in both the cloth and the colour.'
}, {
  title: 'Bangalore & Tiruppur',
  body: 'Designed at our studio in Indira Nagar, manufactured and hand-finished in Tiruppur.'
}];
export function Ethos() {
  return <section className="border-y border-greige/70 bg-parchment" data-id="element-99" data-mp="3qubo4hlg8j42">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-6 py-20 md:grid-cols-3 lg:px-12 lg:py-24" data-id="element-100" data-mp="3uw6s5turlalj">
        {pillars.map((pillar, i) => <div key={pillar.title} data-id="element-101" data-mp="8hvrfr9ql4rb" data-mpi={i}>
            <span className="eyebrow text-clay" data-id="element-102" data-mp="8h3xekvsff35">0{i + 1}</span>
            <h3 className="mt-4 font-display text-2xl font-light text-ink" data-id="element-103" data-mp="dhi3hxdtweyj">{pillar.title}</h3>
            <p className="mt-3 max-w-xs text-sm font-light leading-relaxed text-smoke" data-id="element-104" data-mp="igcmp0fpk5j6">
              {pillar.body}
            </p>
          </div>)}
      </div>
    </section>;
}